
















import Vue from 'vue'

import { DateTimeService } from '../../../base/services/DateTimeService'

export default Vue.extend({
  props: {
    status: {
      type: Object,
      required: true,
      default: {}
    }
  },
  methods: {
    formatTime(ts: number) {
      return DateTimeService.formatUnixTimestamp(ts)
    }
  }
})
